// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/step-forward.js';

import { paths } from '../generated/step-forward';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('step-forward', Original, paths);
